module.exports = __webpack_public_path__ + "img/header-memoireRingsHalfSetMemories@2x.e53b1c2.jpg";